module.exports = __webpack_public_path__ + "static/media/Auto.9c241b34.mp3";